export default function addItemSessionStorage() {
    const flatMenuItems = document.querySelectorAll('.flat-menu_link');
    const promoBtns = document.querySelectorAll('.mega-menu_promo-block_button a');
    const textLinks = document.querySelectorAll("#header_text-carousel .glide__slide a");

    flatMenuItems && flatMenuItems.forEach((item)=>{
        item.addEventListener('click', () => {   
          window && window.sessionStorage.setItem("megamenu_clicked", item.innerText); 
        });
    });

    promoBtns && promoBtns.forEach((item)=>{
        const blockHeading = item.parentElement && item.parentElement.parentElement.querySelector(".mega-menu_promo-block_title").innerHTML.replace(/\s/g, '');
      
        item.addEventListener('click', () => {  
          const attrubutes = {"name": blockHeading, "link": item.href};
      
          window && window.sessionStorage.setItem("megamenu_cta_clicked", JSON.stringify(attrubutes));      
        });
    }); 

    textLinks && textLinks.forEach((item)=>{
      item.addEventListener('click', () => {   
        const attrubutes = {"name": item.innerHTML, "link": item.href};

        window && window.sessionStorage.setItem("navbar_carousel_clicked", JSON.stringify(attrubutes)); 
      });
  });

  let mParticleItemsToLog = {
    header_open_account_btn: '.header_open-account-btn',
    hero_image_btn: '.jumbotron_btn',
    side_column_demo: '.side-column_rounded-div.side-column_demo .fxi-button',
    side_column_joinus: '.side-column_rounded-div.side-column_join-us .fxi-button'
  };

  for (let key in mParticleItemsToLog) {

    let clickedBtn = document.querySelectorAll(mParticleItemsToLog[key]);

    clickedBtn && clickedBtn.forEach((item)=>{
      item.addEventListener('click', (event) => {
        let attributes = {"name": key, "link": item.href, "label": item.text.trim(), "page": window.location.href };
        if(item.href == "#regform" || item.href.indexOf("#regform")) {
          window.mParticle && window.mParticle.logEvent(
            "call_to_action_clicked",
            window.mParticle.EventType.Other,
            attributes
          );
        } else {
          window && window.sessionStorage.setItem("call_to_action_clicked", JSON.stringify(attributes));
        }
      });
    });

  }

}